var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path","fillRule":"evenodd","clipRule":"evenodd","d":"M34 0.899852C34.0003 1.1386 33.9059 1.3676 33.7378 1.53616L17.6273 17.7365C17.2778 18.0878 16.7112 18.0878 16.3617 17.7365L0.251245 1.53616C-0.0879454 1.18302 -0.0830946 0.62167 0.262147 0.274503C0.607389 -0.0726645 1.16562 -0.0775424 1.51681 0.263539L16.9945 15.8275L32.4722 0.263539C32.7282 0.00621709 33.1131 -0.070747 33.4475 0.0685253C33.7819 0.207798 33.9999 0.535888 34 0.899852Z","fill":"white"}));
}

Arrow.defaultProps = {"width":"34","height":"18","viewBox":"0 0 34 18","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
